import AddEditRole from "../Components/Dialogs/AddEditRole";
import RoleDetails from "../Components/Dialogs/RoleDetails";
import RolesTable from "../Components/RolesTable";
import Delete from "../Components/Dialogs/Delete";
import useRoles from "../hooks/useRoles";
const Roles = () => {
  const { deleteRoleLoading, handleDeleteRole } = useRoles();
  return (
    <div>
      <RolesTable />
      <RoleDetails />
      <AddEditRole />
      <Delete
        title="Delete Role"
        subTitle="Are you sure you want to delete this role?"
        loading={deleteRoleLoading}
        fun={handleDeleteRole}
      />
    </div>
  );
};

export default Roles;
